"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.barColors = exports.barSizes = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    progressBar: {
      backgroundColor: theme.palette.grey[200]
    },
    small: {
      borderRadius: 2,
      height: 4,
      "& .MuiLinearProgress-bar": {
        borderRadius: 2
      }
    },
    medium: {
      borderRadius: 4,
      height: 6,
      "& .MuiLinearProgress-bar": {
        borderRadius: 4
      }
    },
    error: {
      "& .MuiLinearProgress-bar": {
        backgroundColor: theme.palette.error.main
      }
    },
    success: {
      "& .MuiLinearProgress-bar": {
        backgroundColor: theme.palette.success.main
      }
    },
    warning: {
      "& .MuiLinearProgress-bar": {
        backgroundColor: theme.palette.warning.main
      }
    },
    square: {
      borderRadius: 0,
      "& .MuiLinearProgress-bar": {
        borderRadius: 0
      }
    }
  };
});
/**
 *
 * ** This module is used to display data in a meaningful and visual way. **
 *
 */

var Bar = function Bar(_ref) {
  var _classNames;

  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "error" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      square = _ref.square;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.LinearProgress, {
    value: value,
    variant: "determinate",
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.progressBar, true), _defineProperty(_classNames, styles[size], true), _defineProperty(_classNames, styles[color], true), _defineProperty(_classNames, styles.square, square), _classNames))
  });
};

Bar.propTypes = {
  /** The value of the Bar */
  value: _propTypes.default.number.isRequired,

  /** The size of the Progress Bar */
  size: _propTypes.default.oneOf(["small", "medium"]),

  /** The available colors of the Bar */
  color: _propTypes.default.oneOf(["error", "success", "warning"]),
  square: _propTypes.default.bool
};
Bar.defaultProps = {
  size: "medium",
  color: "error",
  square: false
};
var barSizes = ["small", "medium"];
exports.barSizes = barSizes;
var barColors = ["error", "success", "warning"];
exports.barColors = barColors;
var _default = Bar;
exports.default = _default;